import { Spinner, Button, Badge, Table, Container, Row, Col, Modal, Form } from 'react-bootstrap';
import { AppContext } from '../context/AppContext';
import { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import Header from '../Common/Header';
import Footer from '../Common/Footer';
import { CSVLink } from 'react-csv';
import * as XLSX from 'xlsx';


const DonorListing = () => {
  const { token, currentUser } = useContext(AppContext);
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false); // New state for view modal
  const [selectedDonor, setSelectedDonor] = useState(null);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 5;
  const [validationError, setValidationError] = useState("");

  useEffect(() => {
    let baseURL = process.env.REACT_APP_API_BASE_URL + 'Donor';
    let headers = {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + token,
    };
    axios.get(baseURL, { headers })
      .then(response => setData(response.data))
      .catch(error => setError(error));
  }, [refresh]);

  const handleEdit = (item) => {
    setSelectedDonor(item);
    setShowModal(true);
  };

  const handleView = (item) => {
    setSelectedDonor(item);
    setShowViewModal(true);
  }; // New function to handle viewing

  const validateForm = () => {   

    if (!selectedDonor.donor_firstname || !selectedDonor.donor_lastname) {
      setValidationError("Please fill out first and last name.");
      return false;
    }
    if (!selectedDonor.donor_address_1 || !selectedDonor.donor_address_town || !selectedDonor.donor_address_postcode) {
      setValidationError("Please fill out complete address.");
      return false;
    }

    if (!selectedDonor.donor_phone) {
      setValidationError("Please fill out phone number.");
      return false;
    }
    if (!selectedDonor.donor_email) {
      setValidationError("Please fill out Email Address.");
      return false;
    }
    if (!selectedDonor.donor_amount) {
      setValidationError("Please fill out Donation Amount.");
      return false;
    }
    if (!selectedDonor.donor_frequency) {
      setValidationError("Please select Donation Frequency.");
      return false;
    }

    // Phone validation: simple check for 10-15 digit phone number (you can customize this regex for your needs)
    const phoneRegex = /^[0-9]{10,15}$/;
    if (!phoneRegex.test(selectedDonor.donor_phone)) {
      setValidationError("Please enter a valid phone number.");
      return false;
    }

    // Email validation
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailRegex.test(selectedDonor.donor_email)) {
      setValidationError("Please enter a valid email address.");
      return false;
    }

    setValidationError(""); // Clear any previous validation errors
    return true;
  };

  const handleSave = async () => {
    // Validate before saving
    if (!validateForm()) return;

    try {
        let baseEditURL = process.env.REACT_APP_API_BASE_URL + 'Donor/'+ selectedDonor.id;  
        let baseAddURL = process.env.REACT_APP_API_BASE_URL + 'Donor';  
   
         let headers = {
           'Content-Type': 'application/json',
           'Authorization': 'Bearer ' + token,
         };
         if (selectedDonor.id) {           
           await axios.put(baseEditURL, selectedDonor, { headers });
         } else {           
           await axios.post(baseAddURL, selectedDonor, { headers });
         }
      setShowModal(false);
      setRefresh(!refresh);
    } catch (error) {
      console.error('Error saving donor', error);
    }
  };

  const filteredData = data.filter(donor => 
    donor.donor_firstname.toLowerCase().includes(search.toLowerCase()) ||
    donor.donor_lastname.toLowerCase().includes(search.toLowerCase())
  );

  const indexOfLastRecord = currentPage * recordsPerPage;
  const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
  const currentRecords = filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
  const totalPages = Math.ceil(filteredData.length / recordsPerPage);

  const csvReport = {
    filename: 'Donor_List.csv',
    headers: [
      { label: 'First Name', key: 'donor_firstname' },
      { label: 'Last Name', key: 'donor_lastname' },
      { label: 'Address Line 1', key: 'donor_address_1' },
      { label: 'Address Line 2', key: 'donor_address_2' },
      { label: 'Town/City', key: 'donor_address_town' },
      { label: 'Postcode', key: 'donor_address_postcode' },
      { label: 'Phone', key: 'donor_phone' },
      { label: 'Email', key: 'donor_email' },
      { label: 'Frequency', key: 'donor_frequency' },
      { label: 'Amount (£)', key: 'donor_amount' },
      { label: 'Gift Aid Consent', key: 'donor_tax_status' },
    ],
    data: filteredData.map(item => ({
      donor_firstname: item.donor_firstname,
      donor_lastname: item.donor_lastname,
      donor_address_1: item.donor_address_1,
      donor_address_2: item.donor_address_2,
      donor_address_town: item.donor_address_town,
      donor_address_postcode: item.donor_address_postcode,
      donor_phone: item.donor_phone,
      donor_email: item.donor_email,
      donor_frequency: item.donor_frequency,
      donor_amount: item.donor_amount,
      donor_tax_status: item.donor_tax_status ? "Yes" : "No",
    })),
  };

  const handleExportExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData.map(item => ({
      'First Name': item.donor_firstname,
      'Last Name': item.donor_lastname,
      'Address Line 1': item.donor_address_1,
      'Address Line 2': item.donor_address_2,
      'Town/City': item.donor_address_town,
      'Postcode': item.donor_address_postcode,
      'Phone': item.donor_phone,
      'Email': item.donor_email,
      'Frequency': item.donor_frequency,
      'Amount (£)': item.donor_amount,
      'Gift Aid Consent': item.donor_tax_status ? "Yes" : "No",
    })));
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Donors");
    XLSX.writeFile(wb, "Donor_List.xlsx");
  };

  return (
    <>    

        {(currentUser.accesstype !== "admin" || currentUser.accesstype !== "superadmin") &&           
          <></>              
        }

{(currentUser.accesstype === "admin" || currentUser.accesstype === "superadmin") && 
      <Container fluid="md" style={{ marginTop: '5px' }}> 
         <Header currentUser={currentUser} titletext={"Donations"} /><br></br>
        <Row className='mb-3'>
          <Col className='col-6'>
            <Form.Control type="text" placeholder="Search by name..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </Col>
          <Col className='col-6 text-end'>
          <Button variant='primary' onClick={() => {
            setSelectedDonor({
              donor_firstname: '',
              donor_lastname: '',
              donor_address_1: '',
              donor_address_2: '',
              donor_address_town: '',
              donor_address_postcode: '',
              donor_phone: '',
              donor_email: '',
              donor_frequency: '',
              donor_amount: 0,
              donor_tax_status: false,
            });
            setShowModal(true);
          }}>Add New Donation
          </Button>
              <CSVLink {...csvReport} className="btn btn-success mx-2">Export to CSV</CSVLink>
              <Button variant="success" onClick={handleExportExcel}>Export to Excel</Button>
            </Col>
          {/* <Col className='col-6 text-end'>
          <Button variant='primary' onClick={() => {
  setSelectedDonor({
    donor_firstname: '',
    donor_lastname: '',
    donor_address_1: '',
    donor_address_2: '',
    donor_address_town: '',
    donor_address_postcode: '',
    donor_phone: '',
    donor_email: '',
    donor_frequency: '',
    donor_amount: 0,
    donor_tax_status: false,
  });
  setShowModal(true);
}}>Add New Donation</Button>

          </Col> */}
        </Row>
        <Row>
          <Col>
            <Table bordered hover responsive="sm" size='sm' variant="light">
              <thead>
                <tr>
                  <th style={{ backgroundColor: 'orange', fontSize: "15px", fontWeight: "bold" }}>Name</th>
                  <th style={{ backgroundColor: 'orange', fontSize: "15px" }}>Frequency</th>
                  <th style={{ backgroundColor: 'orange' }}>Amount (£)</th>
                  <th style={{ backgroundColor: 'orange', fontSize: "15px", fontWeight: "bold" }}>Gift Aid Consent</th>
                  {(currentUser.accesstype === "admin" || currentUser.accesstype === "superadmin") && <th style={{ backgroundColor: 'orange' }}>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {currentRecords.map(item => (
                  <tr key={item.id} style={{ fontSize: "15px" }}>
                    <td><strong>{item?.donor_firstname||""} {item?.donor_lastname||""}</strong></td>
                    <td style={{ textAlign: "left", fontSize: "15px" }}>{item.donor_frequency}</td>
                    <td style={{ textAlign: "left", fontSize: "15px" }}>£ {parseFloat(item.donor_amount).toFixed(2)}</td>
                    <td style={{ textAlign: "left", fontSize: "15px" }}>{item.donor_tax_status ? "Yes" : "No"}</td>
                    {(currentUser.accesstype === "admin" || currentUser.accesstype === "superadmin") && (
                      <td>
                        <Button variant='outline-success' size='sm' onClick={() => handleEdit(item)}>Edit</Button>
                        <Button variant='outline-info' size='sm' onClick={() => handleView(item)} style={{ marginLeft: '5px' }}>View</Button>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </Table>
            <div className="d-flex justify-content-between">
              <Button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>Previous</Button>
              <span>Page {currentPage} of {totalPages}</span>
              <Button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>Next</Button>
            </div>
          </Col>
        </Row>
        <Footer currentUser={currentUser} />
        <Modal show={showModal} onHide={() => setShowModal(false)}>
          <Modal.Header closeButton>
            <Modal.Title>{selectedDonor?.id ? "Edit Donation" : "Add Donation"}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form>
              {validationError && <div style={{ color: 'red' }}>{validationError}</div>}
            
            <Form.Group>
              <Form.Label>First Name(s) *</Form.Label>
              <Form.Control type="text" value={selectedDonor?.donor_firstname || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_firstname: e.target.value })} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Surname *</Form.Label>
              <Form.Control type="text" value={selectedDonor?.donor_lastname || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_lastname: e.target.value })} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Address Line 1 *</Form.Label>
              <Form.Control type="text" value={selectedDonor?.donor_address_1 || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_address_1: e.target.value })} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Address Line 2</Form.Label>
              <Form.Control type="text" value={selectedDonor?.donor_address_2 || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_address_2: e.target.value })} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Town/City *</Form.Label>
              <Form.Control type="text" value={selectedDonor?.donor_address_town || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_address_town: e.target.value })} />
            </Form.Group>
            <Form.Group>
              <Form.Label>Postcode *</Form.Label>
              <Form.Control type="text" value={selectedDonor?.donor_address_postcode || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_address_postcode: e.target.value })} />
            </Form.Group>   
            <Form.Group>
                <Form.Label>Phone</Form.Label>
                <Form.Control type="text" value={selectedDonor?.donor_phone || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_phone: e.target.value })} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" value={selectedDonor?.donor_email || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_email: e.target.value })} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Frequency</Form.Label>
                {/* <Form.Control type="text" value={selectedDonor?.donor_frequency || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_frequency: e.target.value })} /> */}
                <Form.Select value={selectedDonor?.donor_frequency || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_frequency: e.target.value })}>
                <option value="">Select Frequency</option>
                <option value="Monthly">Monthly</option>
                <option value="Annually">Annually</option>
                <option value="One time">One time</option>
              </Form.Select>
              </Form.Group>
              <Form.Group>
                <Form.Label>Amount (£)</Form.Label>
                <Form.Control type="number" value={selectedDonor?.donor_amount || ''} onChange={e => setSelectedDonor({ ...selectedDonor, donor_amount: e.target.value })} />
              </Form.Group>
              <Form.Group>
                <Form.Label>Gift Aid Consent</Form.Label>
                <Form.Check 
                  type="checkbox"
                  checked={selectedDonor?.donor_tax_status || false}
                  onChange={e => setSelectedDonor({ ...selectedDonor, donor_tax_status: e.target.checked })}
                  label="Yes, I consent to Claim Gift Aid"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => {setValidationError(""); setShowModal(false)}}>Close</Button>
            <Button variant="primary" onClick={handleSave}>Save</Button>
          </Modal.Footer>
        </Modal>

        {/* New View Modal */}
                  <Modal show={showViewModal} onHide={() => setShowViewModal(false)}>
                    <Modal.Header closeButton>
                      <Modal.Title>View Donation Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {/* <Form>
                        <Form.Group>
                          <Form.Label><b>Name:</b></Form.Label> {selectedDonor?.donor_firstname || ''} {selectedDonor?.donor_lastname || ''}                         
                        </Form.Group>                       
                        <Form.Group>
                          <Form.Label><b>Address:</b></Form.Label> <br/>
                          {selectedDonor?.donor_address_1 || ''} <br/>
                          {selectedDonor?.donor_address_2 || ''} 
                          {selectedDonor?.donor_address_town || ''} <br/>
                          {selectedDonor?.donor_address_postcode || ''} <br/>
                          <Form.Control type="text" value={selectedDonor?.donor_address_1 || ''} readOnly />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Address Line 2:</Form.Label>
                          <Form.Control type="text" value={selectedDonor?.donor_address_2 || ''} readOnly />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Town/City:</Form.Label>
                          <Form.Control type="text" value={selectedDonor?.donor_address_town || ''} readOnly />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Postcode:</Form.Label>
                          <Form.Control type="text" value={selectedDonor?.donor_address_postcode || ''} readOnly />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Phone:</Form.Label>
                          <Form.Control type="text" value={selectedDonor?.donor_phone || ''} readOnly />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Email:</Form.Label>
                          <Form.Control type="email" value={selectedDonor?.donor_email || ''} readOnly />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Frequency:</Form.Label>
                          <Form.Control type="text" value={selectedDonor?.donor_frequency || ''} readOnly />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Amount (£):</Form.Label>
                          <Form.Control type="number" value={selectedDonor?.donor_amount || ''} readOnly />
                        </Form.Group>
                        <Form.Group>
                          <Form.Label>Gift Aid Consent:</Form.Label>
                          <Form.Check
                            type="checkbox"
                            checked={selectedDonor?.donor_tax_status || false}
                            readOnly
                            label="Yes, I consent to Claim Gift Aid"
                          />
                        </Form.Group>
                      </Form> */}

<div>
      <b>Name:</b> {selectedDonor?.donor_firstname || ''} {selectedDonor?.donor_lastname || ''}<br />     
      <b>Address:</b><br />
      {selectedDonor?.donor_address_1 && <span>{selectedDonor.donor_address_1}<br /></span>}
      {selectedDonor?.donor_address_2 && <span>{selectedDonor.donor_address_2}<br /></span>}
      {selectedDonor?.donor_address_town && <span>{selectedDonor.donor_address_town}<br /></span>}
      {selectedDonor?.donor_address_postcode && <span>{selectedDonor.donor_address_postcode}</span>}<br />
      <b>Phone:</b> {selectedDonor?.donor_phone || ''}<br />
      <b>Email:</b> {selectedDonor?.donor_email || ''}<br />
      <b>Frequency:</b> {selectedDonor?.donor_frequency || ''}<br />
      <b>Amount (£):</b> £{isNaN(parseFloat(selectedDonor?.donor_amount)) ? selectedDonor?.donor_amount : parseFloat(selectedDonor?.donor_amount).toFixed(2)}<br />
      <b>Gift Aid Consent:</b> {selectedDonor?.donor_tax_status ? "Yes" : "No"}<br />
    </div>

                    </Modal.Body>
                    <Modal.Footer>
                      <Button variant="secondary" onClick={() => setShowViewModal(false)}>Close</Button>
                    </Modal.Footer>
                  </Modal>

      </Container>
      }
    </>
  );
}

export default DonorListing;
